// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kavaTestnet as _kavaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kavaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2221
 * Chain Name: Kava EVM Testnet
 * Default Block Explorer: https://testnet.kavascan.com/
 * Default RPC URL: https://evm.testnet.kava.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kavaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kavaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kavaTestnet = createCommon({
	..._kavaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
